import { NgZone, inject, } from "@angular/core";
import { Auth } from "@topyourthree/auth";
import { ModalService } from "@topyourthree/ui";
import * as i0 from "@angular/core";
import * as i1 from "../@topyourthree/ui/modal/modal.component";
export class CompatModalsComponent {
    constructor() {
        this.auth = inject(Auth);
        this.ngZone = inject(NgZone);
        this.modalService = inject(ModalService);
    }
    ngOnInit() {
        const w = window;
        w.webappCompatModals = {
            open: (componentName, config, afterClosedCallback) => this.ngZone.run(() => this.modalService
                // The replace is for backwards compatibility, where places opened eg. `AwardModalComponent`.
                // This supports both `AwardModalComponent` and `AwardModal`.
                .open(componentName.replace("Component", ""), config)
                .afterClosed()
                .then((result) => {
                if (afterClosedCallback) {
                    afterClosedCallback(result);
                }
                return result;
            })),
            // this is used for backwards compatibility reasons to set the credentials from the old stack
            setSession: (userId, token) => this.ngZone.run(() => {
                this.auth.setSession(userId, token);
            }),
        };
        if (w.webappCompatModalsReadyCallback) {
            w.webappCompatModalsReadyCallback();
        }
    }
}
CompatModalsComponent.ɵfac = function CompatModalsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatModalsComponent)(); };
CompatModalsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CompatModalsComponent, selectors: [["webapp-compat-modals"]], decls: 1, vars: 0, template: function CompatModalsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "tyt-modal");
    } }, dependencies: [i1.ModalComponent], encapsulation: 2, changeDetection: 0 });
